<script>
import { InputCheckBox, InputText, InputRadio } from '@/components/Input';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import DateYearMonth from '@/components/DateCustoms/DateYearMonth/main.vue';
import DateTime from '@/components/DateCustoms/DateTime/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import { OPTIONS_TYPE } from '@/components/Campaign/TabClients/constants';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';

export default {
    name: 'CampaignFilterAdvanced',
    components: {
        InputCheckBox,
        InputText,
        InputRadio,

        DateNormal,
        DateYearMonth,
        DateTime,
        Multiselect,
        KeyWordTag,
        ButtonActiveFilter
    },
    props: {
        filter: {
            type: Object,
            required: true
        },
        listDataMasterCampaignType: {
            type: Array,
            default: () => []
        },
        listDataMasterCampaignAdvertising: {
            type: Array,
            default: () => []
        },
        date_from: {
            type: Object,
            required: true
        },
        date_to: {
            type: Object,
            required: true
        },
        checkTodayCampaignEndDate: {
            type: Boolean,
            default: false
        },
        search: {
            type: Object,
            required: true
        },
        campaignStatus: {
            type: Array,
            default: () => []
        },
        checkTodayCampaignStartDate: {
            type: Boolean,
            default: false
        },
        checkTodaySecretariatStartDate: {
            type: Boolean,
            default: false
        },
        checkTodaySecretariatEndDate: {
            type: Boolean,
            default: false
        },
        listDataMasterSaleStaf: {
            type: Array,
            default: () => []
        },
        listDataMasterParttime: {
            type: Array,
            default: () => []
        },
        listDataMasterInstructorStaf: {
            type: Array,
            default: () => []
        },
        sale_staff: {
            type: Array,
            default: () => []
        },
        person_in_charge: {
            type: Array,
            default: () => []
        },
        responsible_sub_persons: {
            type: Array,
            default: () => []
        },
        direction_staff: {
            type: Array,
            default: () => []
        },
        configKeywordOffice: {
            type: Object,
            default: () => ({})
        },
        configKeywordPhoneInformation: {
            type: Object,
            default: () => ({})
        },
        configKeywordMailInformation: {
            type: Object,
            default: () => ({})
        },
        configKeywordOverviewInformation: {
            type: Object,
            default: () => ({})
        },
        listDataMasterOrderScope: {
            type: Array,
            default: () => []
        },
        listFilterScopeDepartment: {
            type: Array,
            default: () => []
        },
        listFilterScopeInquiry: {
            type: Array,
            default: () => []
        },
        listAllPartnersInquiry: {
            type: Array,
            default: () => []
        },
        listAllPartnersApplication: {
            type: Array,
            default: () => []
        },
        listAllPartnersSecretariat: {
            type: Array,
            default: () => []
        },
        listAllPartnersShipping: {
            type: Array,
            default: () => []
        },
        listAllTools: {
            type: Array,
            default: () => []
        },
        scope_partner_inquiry: {
            type: Array,
            default: () => []
        },
        scope_partner_application: {
            type: Array,
            default: () => []
        },
        scope_partner_secretariat: {
            type: Array,
            default: () => []
        },
        scope_partner_shipping: {
            type: Array,
            default: () => []
        },
        tool: {
            type: Array,
            default: () => []
        },
        listFilterScopeApplication: {
            type: Array,
            default: () => []
        },
        listFilterScopeSecretariat: {
            type: Array,
            default: () => []
        },
        listFilterScopeShipping: {
            type: Array,
            default: () => []
        },
        listFilterScopeProduction: {
            type: Array,
            default: () => []
        },
        listFilterScopeSns: {
            type: Array,
            default: () => []
        },
        created_by: {
            type: Array,
            default: () => []
        },
        listProjectManagement: {
            type: Array,
            default: () => []
        },
        listEmployee: {
            type: Array,
            default: () => []
        },
        listDataCustomerTeamPic: {
            type: Array,
            default: () => []
        },
        project_management: {
            type: Array,
            default: () => []
        },
        customer_team_pic: {
            type: Array,
            default: () => ({})
        },
        customer_sub_person: {
            type: Array,
            default: () => ({})
        },
        part_time_employee: {
            type: Array,
            default: () => ({})
        },
        listTypeTitlePrize: {
            type: Array,
            default: () => []
        },
        listPurchaseConditions: {
            type: Array,
            default: () => []
        },
        listTargetProduct: {
            type: Array,
            default: () => []
        },
        listInformationIp: {
            type: Array,
            default: () => []
        },
        listSponsorInformation: {
            type: Array,
            default: () => []
        },
        listSocialPlatform: {
            type: Array,
            default: () => []
        },
        configTotalWin: {
            type: Object,
            default: () => ({})
        },
        configTotalInquiry: {
            type: Object,
            default: () => ({})
        },
        zac_id: {
            type: Array,
            default: () => []
        },
        configKeywordCampaignEntityId: {
            type: Object,
            default: () => ({})
        },
        sfid: {
            type: Array,
            default: () => []
        },
        url: {
            type: Array,
            default: () => []
        },
        offical_name_sns: {
            type: Object,
            default: () => ({})
        },
        offical_id_sns: {
            type: Object,
            default: () => ({})
        },
        configKeywordHashtag: {
            type: Object,
            default: () => ({})
        },
        configKeywordApplicationMethod: {
            type: Object,
            default: () => ({})
        },
        configKeywordInform: {
            type: Object,
            default: () => ({})
        },
        configKeywordInformationIpDetail: {
            type: Object,
            default: () => ({})
        },
        configKeywordTieUpDistributionName: {
            type: Object,
            default: () => ({})
        },
        configKeywordTieUpManufacturerName: {
            type: Object,
            default: () => ({})
        },
        configKeywordContactInformationDm: {
            type: Object,
            default: () => ({})
        },
        configKeywordKeywords: {
            type: Object,
            default: () => ({})
        },
        configKeywordMemo: {
            type: Object,
            default: () => ({})
        },
        prize_search: {
            type: Array,
            default: () => []
        },
        form_url: {
            type: Array,
            default: () => []
        },
        number_of_applications: {
            type: Object,
            default: () => ({})
        },
        initial_quantity: {
            type: Object,
            default: () => ({})
        },
        final_quantity: {
            type: Object,
            default: () => ({})
        },
        increase_quantity: {
            type: Object,
            default: () => ({})
        },
        number_of_inquiries: {
            type: Object,
            default: () => ({})
        },
        social_platforms: {
            type: Object,
            default: () => ({})
        },
        configKeywordCode: {
            type: Object,
            default: () => ({})
        },
        configKeywordName: {
            type: Object,
            default: () => ({})
        },
        configKeywordOrderSource: {
            type: Object,
            default: () => ({})
        },
        configKeywordGenerateFile: {
            type: Object,
            default: () => ({})
        },
        configKeywordZacId: {
            type: Object,
            default: () => ({})
        },
        configKeywordSfid: {
            type: Object,
            default: () => ({})
        },
        configKeywordFormUrl: {
            type: Object,
            default: () => ({})
        },
        configKeywordUrl: {
            type: Object,
            default: () => ({})
        },
        configKeywordPrizeSearch: {
            type: Object,
            default: () => ({})
        },
        configKeywordOfficalNameSns: {
            type: Object,
            default: () => ({})
        },
        configKeywordOfficalIdSns: {
            type: Object,
            default: () => ({})
        },
        activeAccordions: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            OPTIONS_TYPE: OPTIONS_TYPE
        };
    },

    computed: {
        idTargetProductAmount() {
            return this.listPurchaseConditions.find(item => item.value === '対象商品(金額)')?.id;
        },
        idTargetProductQuantity() {
             return this.listPurchaseConditions.find(item => item.value === '対象商品(個数)')?.id;
        },
        idTargetProductTotalAmount() {
             return this.listPurchaseConditions.find(item => item.value === '対象商品合計金額')?.id;
        },
        idDistributionTotalAmount() {
             return this.listPurchaseConditions.find(item => item.value === '流通合計金額')?.id;
        },
        selectedCategoryDetails() {
            if (!this.listDataMasterCampaignType) return [];
            let allCats = [];
            this.listDataMasterCampaignType.forEach((type) => {
                if (type.data) {
                    const categoriesWithType = type.data.map((cat) => ({
                        ...cat,
                        typeValue: type.value
                    }));
                    allCats = allCats.concat(categoriesWithType);
                }
            });
            return allCats.filter((cat) => (this.filter.categories ? this.filter.categories.includes(cat.id) : false));
        },
        configIncreaseQuantity() {
            return {
                ...this.configTotalWin,
                allowNegative: true
            };
        },
        idAdvertisingNone() {
            return this.listDataMasterCampaignAdvertising?.find((item) => item.value === 'なし')?.id;
        },
        showAdvertisingDetails() {
            const selectedIds = this.filter.advertising_activity_id;
            if (!selectedIds || selectedIds.length === 0) return false;
            
            if (this.idAdvertisingNone !== undefined) {
                // Hide if the only selected value is "None"
                if (selectedIds.length === 1 && selectedIds.includes(this.idAdvertisingNone)) {
                    return false;
                }
            }
            return true;
        },
        orderScopeLargeIds() {
            const map = {};
            this.listDataMasterOrderScope.forEach((item) => {
                map[item.value] = item.id;
            });
            return map;
        },
        isSelectedInquiry() {
            return this.filter.order_scope_large ? this.filter.order_scope_large.includes(this.orderScopeLargeIds['お問い合わせ']) : false;
        },
        isSelectedApplication() {
            return this.filter.order_scope_large ? this.filter.order_scope_large.includes(this.orderScopeLargeIds['応募収集']) : false;
        },
        isSelectedSecretariat() {
            return this.filter.order_scope_large ? this.filter.order_scope_large.includes(this.orderScopeLargeIds['事務局関連']) : false;
        },
        isSelectedShipping() {
            return this.filter.order_scope_large ? this.filter.order_scope_large.includes(this.orderScopeLargeIds['発送']) : false;
        },
        isSelectedProduction() {
            return this.filter.order_scope_large ? this.filter.order_scope_large.includes(this.orderScopeLargeIds['制作関連']) : false;
        },
        isSelectedSns() {
            return this.filter.order_scope_large ? this.filter.order_scope_large.includes(this.orderScopeLargeIds['SNSアカウント関連']) : false;
        },
        isSelectedDepartment() {
            return this.filter.order_scope_large ? this.filter.order_scope_large.includes(this.orderScopeLargeIds['資料系']) : false;
        }
    },
    watch: {
        showAdvertisingDetails(val) {
            if (!val) {
                this.$set(this.filter, 'social_platform_id', []);
                this.$emit('update:social_platforms', {});
            }
        },
        'filter.order_scope_large'(newVal) {
            const ids = this.orderScopeLargeIds;
            if (!newVal || newVal.length === 0) {
                this.$set(this.filter, 'order_scope_department', []);
                this.$set(this.filter, 'order_scope_inquiry', []);
                this.$set(this.filter, 'order_scope_inquiry_detail', []);
                this.$set(this.filter, 'order_scope_application', []);
                this.$set(this.filter, 'order_scope_application_detail', []);
                this.$set(this.filter, 'order_scope_secretariat', []);
                this.$set(this.filter, 'order_scope_secretariat_detail', []);
                this.$set(this.filter, 'order_scope_shipping', []);
                this.$set(this.filter, 'order_scope_shipping_detail', []);
                this.$set(this.filter, 'order_scope_production', []);
                this.$set(this.filter, 'order_scope_production_detail', []);
                this.$set(this.filter, 'order_scope_sns_account', []);
                this.$set(this.filter, 'order_scope_sns_account_detail', []);
                return;
            }
            if (!newVal.includes(ids['資料系'])) {
                this.$set(this.filter, 'order_scope_department', []);
            }
            if (!newVal.includes(ids['お問い合わせ'])) {
                this.$set(this.filter, 'order_scope_inquiry', []);
                this.$set(this.filter, 'order_scope_inquiry_detail', []);
            }
            if (!newVal.includes(ids['応募収集'])) {
                this.$set(this.filter, 'order_scope_application', []);
                this.$set(this.filter, 'order_scope_application_detail', []);
            }
            if (!newVal.includes(ids['事務局関連'])) {
                this.$set(this.filter, 'order_scope_secretariat', []);
                this.$set(this.filter, 'order_scope_secretariat_detail', []);
            }
            if (!newVal.includes(ids['発送'])) {
                this.$set(this.filter, 'order_scope_shipping', []);
                this.$set(this.filter, 'order_scope_shipping_detail', []);
            }
            if (!newVal.includes(ids['制作関連'])) {
                this.$set(this.filter, 'order_scope_production', []);
                this.$set(this.filter, 'order_scope_production_detail', []);
            }
            if (!newVal.includes(ids['SNSアカウント関連'])) {
                this.$set(this.filter, 'order_scope_sns_account', []);
                this.$set(this.filter, 'order_scope_sns_account_detail', []);
            }
        }
    },

    methods: {
        updateOfficalIdSns(id, val) {
            const newItem = { ...this.offical_id_sns };
            newItem[id] = val;
            this.$emit('update:offical_id_sns', newItem);
        },
        updateNumberOfApplications(id, type, val) {
            const newItem = { ...this.number_of_applications };
            if (!newItem[id]) {
                newItem[id] = {};
            }
            // If val is event object (from native input), use target.value, otherwise use val directly (from custom component)
            // Checking how InputText emits. In offical_name_sns it uses $event.
            // If InputText emits a value directly, we use it. 
            // Based on offical_name_sns usage: @input="updateOfficalNameSns(cat.id, $event)"
            // It seems $event is the value or event. 
            // Let's assume val is the value for now, or check InputText implementation if possible.
            // But waiting, offical_name_sns uses $event. 
            // Safe bet:
            const value = val; 
            
            newItem[id][type] = value;
            this.$emit('update:number_of_applications', newItem);
        },
        updateInitialQuantity(id, type, val) {
            const newItem = { ...this.initial_quantity };
            if (!newItem[id]) {
                newItem[id] = {};
            }
            newItem[id][type] = val;
            this.$emit('update:initial_quantity', newItem);
        },
        updateFinalQuantity(id, type, val) {
            const newItem = { ...this.final_quantity };
            if (!newItem[id]) {
                newItem[id] = {};
            }
            newItem[id][type] = val;
            this.$emit('update:final_quantity', newItem);
        },
        updateIncreaseQuantity(id, type, val) {
            const newItem = { ...this.increase_quantity };
            if (!newItem[id]) {
                newItem[id] = {};
            }
            newItem[id][type] = val;
            this.$emit('update:increase_quantity', newItem);
        },
        updateNumberOfInquiries(id, type, val) {
            const newItem = { ...this.number_of_inquiries };
            if (!newItem[id]) {
                newItem[id] = {};
            }
            newItem[id][type] = val;
            this.$emit('update:number_of_inquiries', newItem);
        },
        updateSocialPlatforms(id, type, val) {
            const newItem = { ...this.social_platforms };
            if (!newItem[id]) {
                newItem[id] = {};
            }
            newItem[id][type] = val;
            this.$emit('update:social_platforms', newItem);
        },
        updateOfficalNameSns(id, val) {
            this.$emit('update:offical_name_sns', { ...this.offical_name_sns, [id]: val });
        },
        getAppCond1ForCat(catId) {
            return this.filter.application_condition_1[catId] || [];
        },
        updateAppCond1(catId, newVal) {
            const updated = { ...this.filter.application_condition_1, [catId]: newVal };
            this.$set(this.filter, 'application_condition_1', updated);
        },
        getAppCond2ForCat(catId) {
            return this.filter.application_condition_2[catId] || [];
        },
        updateAppCond2(catId, newVal) {
            const updated = { ...this.filter.application_condition_2, [catId]: newVal };
            this.$set(this.filter, 'application_condition_2', updated);
        },

        handleChangeFilterApplication(item) {
            this.$emit('changeFilterApplication', item);
        },
        handleChangeFilterSecretariat(item) {
            this.$emit('changeFilterSecretariat', item);
        },
        handleChangeFilterSecretariatDetail(item) {
            this.$emit('changeFilterSecretariatDetail', item);
        },
        handleChangeFilterShipping(item) {
            this.$emit('changeFilterShipping', item);
        },
        handleChangeFilterProduction(item) {
            this.$emit('changeFilterProduction', item);
        },
        handleChangeFilterSns(item) {
            this.$emit('changeFilterSns', item);
        },
        handleChangeFilterInquiry(item) {
            this.$emit('changeFilterInquiry', item);
        },
        onClearDate(obj, key, isTime = false) {
            this.$set(obj, key, '');
            this.$set(obj, key + '_y', '');
            this.$set(obj, key + '_m', '');
            this.$set(obj, key + '_d', '');
            if (isTime) {
                this.$set(obj, key + '_full_time', '');
            }
        },
        clearSection(section) {
            switch (section) {
                case 'overview':
                    if (this.configKeywordCode) this.configKeywordCode.arrayTag = [];
                    if (this.configKeywordName) this.configKeywordName.arrayTag = [];
                    this.filter.progress_status = [];
                    this.filter.campaign_type = '';
                    this.filter.categories = [];
                    this.$set(this.filter, 'application_condition_1', {});
                    this.$set(this.filter, 'application_condition_2', {});
                    if (this.configKeywordApplicationMethod) {
                        Object.keys(this.configKeywordApplicationMethod).forEach((key) => {
                            this.configKeywordApplicationMethod[key].arrayTag = [];
                        });
                    }
                    if (this.configKeywordOfficalNameSns) {
                        Object.keys(this.configKeywordOfficalNameSns).forEach((key) => {
                            this.configKeywordOfficalNameSns[key].arrayTag = [];
                        });
                    }
                    if (this.configKeywordOfficalIdSns) {
                        Object.keys(this.configKeywordOfficalIdSns).forEach((key) => {
                            this.configKeywordOfficalIdSns[key].arrayTag = [];
                        });
                    }
                    if (this.configKeywordHashtag) {
                        Object.keys(this.configKeywordHashtag).forEach((key) => {
                            this.configKeywordHashtag[key].arrayTag = [];
                        });
                    }
                    this.$emit('update:number_of_applications', {});
                    this.$emit('update:initial_quantity', {});
                    this.$emit('update:final_quantity', {});
                    this.$emit('update:increase_quantity', {});
                    if (this.configKeywordFormUrl) this.configKeywordFormUrl.arrayTag = [];
                    this.date_from.total_application_from = '';
                    this.date_to.total_application_to = '';
                    break;
                case 'period':
                    this.onClearDate(this.date_from, 'campaign_start_date_time', true);
                    this.onClearDate(this.date_to, 'campaign_start_date_time', true);
                    this.onClearDate(this.date_from, 'campaign_end_date_time', true);
                    this.onClearDate(this.date_to, 'campaign_end_date_time', true);
                    this.onClearDate(this.date_from, 'secretariat_start_date_time', true);
                    this.onClearDate(this.date_to, 'secretariat_start_date_time', true);
                    this.onClearDate(this.date_from, 'secretariat_end_date_time', true);
                    this.onClearDate(this.date_to, 'secretariat_end_date_time', true);
                    this.onClearDate(this.date_from, 'receipt_expiration_start_date');
                    this.onClearDate(this.date_to, 'receipt_expiration_start_date');
                    this.onClearDate(this.date_from, 'receipt_expiration_end_date');
                    this.onClearDate(this.date_to, 'receipt_expiration_end_date');
                    this.filter.is_before_due_date = [];
                    this.filter.is_post_effective_date = [];
                    this.filter.year_end_holiday = [];
                    break;
                case 'product':
                    this.filter.purchase_conditions = [];
                    this.date_from.target_product_amount_from = '';
                    this.date_to.target_product_amount_to = '';
                    this.date_from.target_product_quantity_from = '';
                    this.date_to.target_product_quantity_to = '';
                    this.date_from.target_product_total_amount_from = '';
                    this.date_to.target_product_total_amount_to = '';
                    this.date_from.distribution_total_amount_from = '';
                    this.date_to.distribution_total_amount_to = '';
                    this.filter.target_product_list_1 = [];
                    this.filter.target_product_list_2 = [];
                    break;
                case 'site':
                    if (this.configKeywordInform) this.configKeywordInform.arrayTag = [];
                    if (this.configKeywordUrl) this.configKeywordUrl.arrayTag = [];
                    this.onClearDate(this.date_from, 'url_publish_time_from');
                    this.onClearDate(this.date_to, 'url_publish_time_from');
                    this.onClearDate(this.date_from, 'url_publish_time_to');
                    this.onClearDate(this.date_to, 'url_publish_time_to');
                    this.filter.information_ip = [];
                    this.filter.information_ip_detail = [];
                    if (this.configKeywordInformationIpDetail) this.configKeywordInformationIpDetail.arrayTag = [];
                    this.filter.sponsor_information = [];
                    this.date_from.circulation_number_from = '';
                    this.date_to.circulation_number_to = '';
                    if (this.configKeywordTieUpDistributionName) this.configKeywordTieUpDistributionName.arrayTag = [];
                    this.date_from.up_manufacturers_from = '';
                    this.date_to.up_manufacturers_to = '';
                    if (this.configKeywordTieUpManufacturerName) this.configKeywordTieUpManufacturerName.arrayTag = [];
                    break;
                case 'prize':
                    this.date_from.total_win_from = '';
                    this.date_to.total_win_to = '';
                    this.onClearDate(this.date_from, 'prize_shipping_period');
                    this.onClearDate(this.date_to, 'prize_shipping_period');
                    this.date_from.quantity_for_event_prize = '';
                    this.date_to.quantity_for_event_prize = '';
                    if (this.configKeywordPrizeSearch) this.configKeywordPrizeSearch.arrayTag = [];
                    this.date_from.number_of_win_prize = '';
                    this.date_to.number_of_win_prize = '';
                    this.filter.prize_type = [];
                    this.filter.prize_type_detail = [];
                    break;
                case 'inquiry':
                    if (this.configKeywordOffice) this.configKeywordOffice.arrayTag = [];
                    if (this.configKeywordPhoneInformation) this.configKeywordPhoneInformation.arrayTag = [];
                    if (this.configKeywordMailInformation) this.configKeywordMailInformation.arrayTag = [];
                    if (this.configKeywordContactInformationDm) this.configKeywordContactInformationDm.arrayTag = [];
                    this.date_from.total_inquiry_from = '';
                    this.date_to.total_inquiry_to = '';
                    this.$emit('update:number_of_inquiries', {});
                    break;
                case 'other':
                    this.onClearDate(this.date_from, 'campaign_create_date');
                    this.onClearDate(this.date_to, 'campaign_create_date');
                    this.$emit('update:created_by', []);
                    if (this.configKeywordOverviewInformation) this.configKeywordOverviewInformation.arrayTag = [];
                    if (this.configKeywordZacId) this.configKeywordZacId.arrayTag = [];
                    if (this.configKeywordSfid) this.configKeywordSfid.arrayTag = [];
                    if (this.configKeywordCampaignEntityId) this.configKeywordCampaignEntityId.arrayTag = [];
                    if (this.configKeywordKeywords) this.configKeywordKeywords.arrayTag = [];
                    if (this.configKeywordMemo) this.configKeywordMemo.arrayTag = [];
                    break;
                case 'scope':
                    this.filter.order_scope_large = [];
                    this.filter.order_scope_department = [];
                    this.filter.order_scope_inquiry = [];
                    this.filter.order_scope_inquiry_detail = [];
                    this.filter.order_scope_application = [];
                    this.filter.order_scope_application_detail = [];
                    this.filter.order_scope_secretariat = [];
                    this.filter.order_scope_secretariat_detail = [];
                    this.filter.order_scope_shipping = [];
                    this.filter.order_scope_shipping_detail = [];
                    this.filter.order_scope_production = [];
                    this.filter.order_scope_production_detail = [];
                    this.filter.order_scope_sns_account = [];
                    this.filter.order_scope_sns_account_detail = [];
                    this.$emit('update:scope_partner_inquiry', []);
                    this.$emit('update:scope_partner_application', []);
                    this.$emit('update:scope_partner_secretariat', []);
                    this.$emit('update:scope_partner_shipping', []);
                    this.$emit('update:tool', []);
                    break;
                case 'customer':
                    if (this.configKeywordOrderSource) this.configKeywordOrderSource.arrayTag = [];
                    if (this.configKeywordGenerateFile) this.configKeywordGenerateFile.arrayTag = [];
                    this.filter.client_order_source_type = [];
                    this.filter.client_generate_file_type = [];
                    break;
                case 'staff':
                    this.$emit('update:sale_staff', []);
                    this.$emit('update:person_in_charge', []);
                    this.$emit('update:responsible_sub_persons', []);
                    this.$emit('update:project_management', []);
                    this.$emit('update:customer_team_pic', []);
                    this.$emit('update:customer_sub_person', []);
                    this.$emit('update:part_time_employee', []);
                    break;
                case 'advertising':
                    this.filter.advertising_activity_id = [];
                    this.filter.social_platform_id = [];
                    this.$emit('update:social_platforms', {});
                    this.filter.give_away_related = [];
                    break;
            }
        }
    }
};
</script>

<template>
    <div>
        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【概要情報】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.overview" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.overview" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">CP番号</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordCode" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">ステータス</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <div v-for="item in campaignStatus" :key="item.id + 's'">
                                <InputCheckBox
                                    class="mr-3 mb-2"
                                    :model.sync="filter.progress_status"
                                    :id="`check-progress_status_${item.id}`"
                                    :value="item.id"
                                    :label="item.text"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">キャンペーン名</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordName" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">キャンペーン種別</label>
                    <div class="col-sm-9">
                        <div class="d-flex">
                            <div v-for="item in listDataMasterCampaignType" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="filter.campaign_type"
                                    :name="`CampaignType`"
                                    :id="`CampaignType-${item.id}`"
                                    :value="item.id"
                                    :label="item.value"
                                />
                            </div>
                            <div>
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="filter.campaign_type"
                                    :name="`CampaignType`"
                                    id="CampaignType-null"
                                    :value="'null'"
                                    label="指定なし"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="filter.campaign_type && filter.campaign_type !== 'null'" class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">応募種別</label>
                    <div class="col-sm-9">
                        <div v-for="campaignType in listDataMasterCampaignType" :key="campaignType.id">
                            <div v-if="filter.campaign_type == campaignType.id">
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="item in campaignType.data"
                                        :key="item.id"
                                        class="mr-4"
                                        :model.sync="filter.categories"
                                        :name="`CampaignType`"
                                        :id="`CampaignType-${item.id}`"
                                        :value="item.id"
                                        :label="item.value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-for="cat in selectedCategoryDetails">
                    <div
                        :key="'cond1-' + cat.id"
                        class="form-group row"
                        v-if="cat.data && cat.data.length > 0"
                    >
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }}): 応募条件①</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                <InputCheckBox
                                    v-for="child1 in cat.data"
                                    :key="child1.id"
                                    class="mr-4"
                                    :model="getAppCond1ForCat(cat.id)"
                                    @update:model="updateAppCond1(cat.id, $event)"
                                    :name="`applicationCondition1-${child1.id}`"
                                    :id="`applicationCondition1-${child1.id}`"
                                    :value="child1.id"
                                    :label="child1.value"
                                />
                            </div>
                        </div>
                    </div>
                    <template v-for="child1 in cat.data">
                         <div
                            :key="'cond2-' + child1.id"
                            class="form-group row"
                            v-if="
                                getAppCond1ForCat(cat.id).includes(child1.id) &&
                                child1.data &&
                                child1.data.length > 0
                            "
                        >
                            <label class="col-sm-3" for="validationCustom05">{{ child1.value }}({{ cat.value }}({{ cat.typeValue }})):応募条件②</label>
                            <div class="col-sm-9">
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="child2 in child1.data"
                                        :key="child2.id"
                                        class="mr-4"
                                        :model="getAppCond2ForCat(cat.id)"
                                        @update:model="updateAppCond2(cat.id, $event)"
                                        :name="`applicationCondition2-${child2.id}`"
                                        :id="`applicationCondition2-${child2.id}`"
                                        :value="child2.id"
                                        :label="child2.value"
                                    />
                                </div>
                            </div>
                        </div>
                    </template>
            
                    <div :key="'method-' + cat.id" class="form-group row">
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }})：応募方法</label>
                        <div class="col-sm-9">
                            <KeyWordTag v-if="configKeywordApplicationMethod[cat.id]" :config="configKeywordApplicationMethod[cat.id]" class="" />
                        </div>
                    </div>
                    <div :key="'name-' + cat.id" class="form-group row" v-if="['X', 'Instagram', 'LINE', 'TikTok'].includes(cat.value)">
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }})：公式アカウント名</label>
                        <div class="col-sm-9">
                            <KeyWordTag v-if="configKeywordOfficalNameSns[cat.id]" :config="configKeywordOfficalNameSns[cat.id]" class="" />
                        </div>
                    </div>
                    <div :key="'id-' + cat.id" class="form-group row" v-if="['X', 'Instagram', 'LINE', 'TikTok'].includes(cat.value)">
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }})：公式アカウントID</label>
                        <div class="col-sm-9">
                            <KeyWordTag v-if="configKeywordOfficalIdSns[cat.id]" :config="configKeywordOfficalIdSns[cat.id]" class="" />
                        </div>
                    </div>
                    <div :key="'hash-' + cat.id" class="form-group row" v-if="['X', 'Instagram', 'TikTok'].includes(cat.value)">
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }})：ハッシュタグ</label>
                        <div class="col-sm-9">
                            <KeyWordTag v-if="configKeywordHashtag[cat.id]" :config="configKeywordHashtag[cat.id]" class="" />
                        </div>
                    </div>
                    <div :key="'num_app-' + cat.id" class="form-group row">
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }})：応募数</label>
                        <div class="col-sm-9 d-flex">
                            <div class="d-flex align-items-center mr-2">
                                <InputText
                                    class="mr-2"
                                    :model="number_of_applications[cat.id] ? number_of_applications[cat.id].from : ''"
                                    @input="updateNumberOfApplications(cat.id, 'from', $event)"
                                    :config="configTotalWin"
                                />
                                から
                            </div>
                            <div class="d-flex align-items-center">
                                <InputText
                                    class="mr-2"
                                    :model="number_of_applications[cat.id] ? number_of_applications[cat.id].to : ''"
                                    @input="updateNumberOfApplications(cat.id, 'to', $event)"
                                    :config="configTotalWin"
                                />
                                まで
                            </div>
                        </div>
                    </div>
                    <div :key="'init_qty-' + cat.id" class="form-group row">
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }})：初回数量</label>
                        <div class="col-sm-9 d-flex">
                            <div class="d-flex align-items-center mr-2">
                                <InputText
                                    class="mr-2"
                                    :model="initial_quantity[cat.id] ? initial_quantity[cat.id].from : ''"
                                    @input="updateInitialQuantity(cat.id, 'from', $event)"
                                    :config="configTotalWin"
                                />
                                から
                            </div>
                            <div class="d-flex align-items-center">
                                <InputText
                                    class="mr-2"
                                    :model="initial_quantity[cat.id] ? initial_quantity[cat.id].to : ''"
                                    @input="updateInitialQuantity(cat.id, 'to', $event)"
                                    :config="configTotalWin"
                                />
                                まで
                            </div>
                        </div>
                    </div>
                    <div :key="'final_qty-' + cat.id" class="form-group row">
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }})：最終数量</label>
                        <div class="col-sm-9 d-flex">
                            <div class="d-flex align-items-center mr-2">
                                <InputText
                                    class="mr-2"
                                    :model="final_quantity[cat.id] ? final_quantity[cat.id].from : ''"
                                    @input="updateFinalQuantity(cat.id, 'from', $event)"
                                    :config="configTotalWin"
                                />
                                から
                            </div>
                            <div class="d-flex align-items-center">
                                <InputText
                                    class="mr-2"
                                    :model="final_quantity[cat.id] ? final_quantity[cat.id].to : ''"
                                    @input="updateFinalQuantity(cat.id, 'to', $event)"
                                    :config="configTotalWin"
                                />
                                まで
                            </div>
                        </div>
                    </div>
                    <div :key="'inc_qty-' + cat.id" class="form-group row">
                        <label class="col-sm-3" for="validationCustom05">{{ cat.value }}({{ cat.typeValue }})：増加数量</label>
                        <div class="col-sm-9 d-flex">
                            <div class="d-flex align-items-center mr-2">
                                <InputText
                                    class="mr-2"
                                    :model="increase_quantity[cat.id] ? increase_quantity[cat.id].from : ''"
                                    @input="updateIncreaseQuantity(cat.id, 'from', $event)"
                                    :config="configIncreaseQuantity"
                                />
                                から
                            </div>
                            <div class="d-flex align-items-center">
                                <InputText
                                    class="mr-2"
                                    :model="increase_quantity[cat.id] ? increase_quantity[cat.id].to : ''"
                                    @input="updateIncreaseQuantity(cat.id, 'to', $event)"
                                    :config="configIncreaseQuantity"
                                />
                                まで
                            </div>
                        </div>
                    </div>
                </template>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">WEB：応募フォームURL</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordFormUrl" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">総応募数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.total_application_from" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.total_application_to" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('overview')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【期間関連】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.period" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.period" class="p-4">
                <!-- <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">キャンペーン開始日</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :year.sync="date_from.campaign_start_date_y"
                                :month.sync="date_from.campaign_start_date_m"
                                :day.sync="date_from.campaign_start_date_d"
                                :full_date.sync="date_from.campaign_start_date"
                                :disabled="checkTodayCampaignStartDate"
                                :config="{
                                    error: false
                                }"
                            ></DateNormal>
                            から
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'campaign_start_date')">クリア</button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :year.sync="date_to.campaign_start_date_y"
                                :month.sync="date_to.campaign_start_date_m"
                                :day.sync="date_to.campaign_start_date_d"
                                :full_date.sync="date_to.campaign_start_date"
                                :disabled="checkTodayCampaignStartDate"
                                :config="{
                                    error: false
                                }"
                            ></DateNormal>
                            まで
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'campaign_start_date')">クリア</button>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div> -->
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">キャンペーン開始時間</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateTime
                                :year.sync="date_from.campaign_start_date_time_y"
                                :month.sync="date_from.campaign_start_date_time_m"
                                :day.sync="date_from.campaign_start_date_time_d"
                                :full_date.sync="date_from.campaign_start_date_time"
                                :full_time.sync="date_from.campaign_start_date_time_full_time"
                                :allowOnlyTime="true"
                                :config="{
                                    error: false
                                }"
                            ></DateTime>
                            から
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'campaign_start_date_time', true)">クリア</button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateTime
                                :year.sync="date_to.campaign_start_date_time_y"
                                :month.sync="date_to.campaign_start_date_time_m"
                                :day.sync="date_to.campaign_start_date_time_d"
                                :full_date.sync="date_to.campaign_start_date_time"
                                :full_time.sync="date_to.campaign_start_date_time_full_time"
                                :allowOnlyTime="true"
                                :config="{
                                    error: false
                                }"
                            ></DateTime>
                            まで
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'campaign_start_date_time', true)">クリア</button>
                        </div>
                    </div>
                </div>
                <!-- <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">キャンペーン終了日</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :year.sync="date_from.campaign_end_date_y"
                                :month.sync="date_from.campaign_end_date_m"
                                :day.sync="date_from.campaign_end_date_d"
                                :full_date.sync="date_from.campaign_end_date"
                                :disabled="checkTodayCampaignEndDate"
                                :config="{
                                    error: false
                                }"
                            ></DateNormal>
                            から
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'campaign_end_date')">クリア</button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :year.sync="date_to.campaign_end_date_y"
                                :month.sync="date_to.campaign_end_date_m"
                                :day.sync="date_to.campaign_end_date_d"
                                :full_date.sync="date_to.campaign_end_date"
                                :disabled="checkTodayCampaignEndDate"
                                :config="{
                                    error: false
                                }"
                            ></DateNormal>
                            まで
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'campaign_end_date')">クリア</button>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div> -->
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">キャンペーン終了時間</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateTime
                                :year.sync="date_from.campaign_end_date_time_y"
                                :month.sync="date_from.campaign_end_date_time_m"
                                :day.sync="date_from.campaign_end_date_time_d"
                                :full_date.sync="date_from.campaign_end_date_time"
                                :full_time.sync="date_from.campaign_end_date_time_full_time"
                                :allowOnlyTime="true"
                                :config="{
                                    error: false
                                }"
                            ></DateTime>
                            から
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'campaign_end_date_time', true)">クリア</button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateTime
                                :year.sync="date_to.campaign_end_date_time_y"
                                :month.sync="date_to.campaign_end_date_time_m"
                                :day.sync="date_to.campaign_end_date_time_d"
                                :full_date.sync="date_to.campaign_end_date_time"
                                :full_time.sync="date_to.campaign_end_date_time_full_time"
                                :allowOnlyTime="true"
                                :config="{
                                    error: false
                                }"
                            ></DateTime>
                            まで
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'campaign_end_date_time', true)">クリア</button>
                        </div>
                    </div>
                </div>
        
                <!-- <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">事務局開始日</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :year.sync="date_from.secretariat_start_date_y"
                                :month.sync="date_from.secretariat_start_date_m"
                                :day.sync="date_from.secretariat_start_date_d"
                                :full_date.sync="date_from.secretariat_start_date"
                                :disabled="checkTodaySecretariatStartDate"
                                :config="{
                                    error: false
                                }"
                            ></DateNormal>
                            から
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'secretariat_start_date')">クリア</button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :year.sync="date_to.secretariat_start_date_y"
                                :month.sync="date_to.secretariat_start_date_m"
                                :day.sync="date_to.secretariat_start_date_d"
                                :full_date.sync="date_to.secretariat_start_date"
                                :disabled="checkTodaySecretariatStartDate"
                                :config="{
                                    error: false
                                }"
                            ></DateNormal>
                            まで
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'secretariat_start_date')">クリア</button>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div> -->
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">事務局開始時間</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateTime
                                :year.sync="date_from.secretariat_start_date_time_y"
                                :month.sync="date_from.secretariat_start_date_time_m"
                                :day.sync="date_from.secretariat_start_date_time_d"
                                :full_date.sync="date_from.secretariat_start_date_time"
                                :full_time.sync="date_from.secretariat_start_date_time_full_time"
                                :config="{
                                    error: false
                                }"
                                :allowOnlyTime="true"
                            ></DateTime>
                            から
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'secretariat_start_date_time', true)">クリア</button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateTime
                                :year.sync="date_to.secretariat_start_date_time_y"
                                :month.sync="date_to.secretariat_start_date_time_m"
                                :day.sync="date_to.secretariat_start_date_time_d"
                                :full_date.sync="date_to.secretariat_start_date_time"
                                :full_time.sync="date_to.secretariat_start_date_time_full_time"
                                :config="{
                                    error: false
                                }"
                                :allowOnlyTime="true"
                            ></DateTime>
                            まで
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'secretariat_start_date_time', true)">クリア</button>
                        </div>
                    </div>
                </div>
                <!-- <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">事務局終了日</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :year.sync="date_from.secretariat_end_date_y"
                                :month.sync="date_from.secretariat_end_date_m"
                                :day.sync="date_from.secretariat_end_date_d"
                                :full_date.sync="date_from.secretariat_end_date"
                                :disabled="checkTodaySecretariatEndDate"
                                :config="{
                                    error: false
                                }"
                            ></DateNormal>
                            から
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'secretariat_end_date')">クリア</button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :year.sync="date_to.secretariat_end_date_y"
                                :month.sync="date_to.secretariat_end_date_m"
                                :day.sync="date_to.secretariat_end_date_d"
                                :full_date.sync="date_to.secretariat_end_date"
                                :disabled="checkTodaySecretariatEndDate"
                                :config="{
                                    error: false
                                }"
                            ></DateNormal>
                            まで
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'secretariat_end_date')">クリア</button>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div> -->
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">事務局終了時間</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateTime
                                :year.sync="date_from.secretariat_end_date_time_y"
                                :month.sync="date_from.secretariat_end_date_time_m"
                                :day.sync="date_from.secretariat_end_date_time_d"
                                :full_date.sync="date_from.secretariat_end_date_time"
                                :full_time.sync="date_from.secretariat_end_date_time_full_time"
                                :config="{
                                    error: false
                                }"
                                :allowOnlyTime="true"
                            ></DateTime>
                            から
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'secretariat_end_date_time', true)">クリア</button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateTime
                                :year.sync="date_to.secretariat_end_date_time_y"
                                :month.sync="date_to.secretariat_end_date_time_m"
                                :day.sync="date_to.secretariat_end_date_time_d"
                                :full_date.sync="date_to.secretariat_end_date_time"
                                :full_time.sync="date_to.secretariat_end_date_time_full_time"
                                :config="{
                                    error: false
                                }"
                                :allowOnlyTime="true"
                            ></DateTime>
                            まで
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'secretariat_end_date_time', true)">クリア</button>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">レシート有効期限開始日</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_from.receipt_expiration_start_date_y"
                                    :month.sync="date_from.receipt_expiration_start_date_m"
                                    :day.sync="date_from.receipt_expiration_start_date_d"
                                    :full_date.sync="date_from.receipt_expiration_start_date"
                                    :config="{
                                        error: false
                                    }"
                                ></DateNormal>
                                から
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'receipt_expiration_start_date')">クリア</button>
                            </div>
                            ～
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_to.receipt_expiration_start_date_y"
                                    :month.sync="date_to.receipt_expiration_start_date_m"
                                    :day.sync="date_to.receipt_expiration_start_date_d"
                                    :full_date.sync="date_to.receipt_expiration_start_date"
                                    :config="{
                                        error: false
                                    }"
                                ></DateNormal>
                                まで
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'receipt_expiration_start_date')">クリア</button>
                            </div>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">レシート有効期限終了日</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_from.receipt_expiration_end_date_y"
                                    :month.sync="date_from.receipt_expiration_end_date_m"
                                    :day.sync="date_from.receipt_expiration_end_date_d"
                                    :full_date.sync="date_from.receipt_expiration_end_date"
                                    :config="{
                                        error: false
                                    }"
                                ></DateNormal>
                                から
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'receipt_expiration_end_date')">クリア</button>
                            </div>
                            ～
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_to.receipt_expiration_end_date_y"
                                    :month.sync="date_to.receipt_expiration_end_date_m"
                                    :day.sync="date_to.receipt_expiration_end_date_d"
                                    :full_date.sync="date_to.receipt_expiration_end_date"
                                    :config="{
                                        error: false
                                    }"
                                ></DateNormal>
                                まで
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'receipt_expiration_end_date')">クリア</button>
                            </div>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">ハガキ有効条件</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <InputCheckBox
                                class="mr-3 mb-2"
                                :model.sync="filter.is_before_due_date"
                                id="check-is_before_due_date"
                                value="1"
                                label="必着"
                            />
                            <InputCheckBox
                                class="mr-3 mb-2"
                                :model.sync="filter.is_post_effective_date"
                                id="check-is_post_effective_date"
                                value="1"
                                label="当日消印有効"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">年末年始休み</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <InputCheckBox
                                class="mr-3 mb-2"
                                :model.sync="filter.year_end_holiday"
                                id="check-year_end_holiday-1"
                                value="1"
                                label="あり"
                            />
                            <InputCheckBox
                                class="mr-3 mb-2"
                                :model.sync="filter.year_end_holiday"
                                id="check-year_end_holiday-0"
                                value="0"
                                label="なし"
                            />
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('period')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【商品関連】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.product" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.product" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">購買条件</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listPurchaseConditions"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.purchase_conditions"
                                :name="`purchaseConditions-${item.id}`"
                                :id="`purchaseConditions-${item.id}`"
                                :value="item.id"
                                :label="item.value"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group row" v-if="idTargetProductAmount && filter.purchase_conditions.includes(idTargetProductAmount)">
                    <label class="col-sm-3" for="validationCustom05">対象商品金額</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.target_product_amount_from" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.target_product_amount_to" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>

                <div class="form-group row" v-if="idTargetProductQuantity && filter.purchase_conditions.includes(idTargetProductQuantity)">
                    <label class="col-sm-3" for="validationCustom05">対象商品個数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.target_product_quantity_from" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.target_product_quantity_to" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>

                <div class="form-group row" v-if="idTargetProductTotalAmount && filter.purchase_conditions.includes(idTargetProductTotalAmount)">
                    <label class="col-sm-3" for="validationCustom05">対象商品合計金額</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.target_product_total_amount_from" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.target_product_total_amount_to" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>

                <div class="form-group row" v-if="idDistributionTotalAmount && filter.purchase_conditions.includes(idDistributionTotalAmount)">
                    <label class="col-sm-3" for="validationCustom05">流通合計金額</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.distribution_total_amount_from" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.distribution_total_amount_to" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">対象商品カテゴリ1</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listTargetProduct"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.target_product_list_1"
                                :name="`targetProduct1-${item.id}`"
                                :id="`targetProduct1-${item.id}`"
                                :value="item.id"
                                :label="item.value"
                            />
                        </div>
                    </div>
                </div>

                <template v-for="item in listTargetProduct">
                    <div
                        :key="'targetProduct2-' + item.id"
                        class="form-group row"
                        v-if="filter.target_product_list_1.includes(item.id) && item.data && item.data.length > 0"
                    >
                        <label class="col-sm-3" for="validationCustom05">{{ item.value }}: 対象商品カテゴリ2</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                <InputCheckBox
                                    v-for="child in item.data"
                                    :key="child.id"
                                    class="mr-4"
                                    :model.sync="filter.target_product_list_2"
                                    :name="`targetProduct2-${child.id}`"
                                    :id="`targetProduct2-${child.id}`"
                                    :value="child.id"
                                    :label="child.value"
                                />
                            </div>
                        </div>
                    </div>
                </template>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('product')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【告知サイト関連】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.site" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.site" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">キャンペーン告知</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordInform" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">LPサイト</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordUrl" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">公開開始期間</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_from.url_publish_time_from_y"
                                    :month.sync="date_from.url_publish_time_from_m"
                                    :day.sync="date_from.url_publish_time_from_d"
                                    :full_date.sync="date_from.url_publish_time_from"
                                    :config="{
                                        error: false
                                    }"
                                >
                                </DateNormal>
                                から
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'url_publish_time_from')">クリア</button>
                            </div>
                            ～
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_to.url_publish_time_from_y"
                                    :month.sync="date_to.url_publish_time_from_m"
                                    :day.sync="date_to.url_publish_time_from_d"
                                    :full_date.sync="date_to.url_publish_time_from"
                                    :config="{
                                        error: false
                                    }"
                                >
                                </DateNormal>
                                まで
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'url_publish_time_from')">クリア</button>
                            </div>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">公開終了期間</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_from.url_publish_time_to_y"
                                    :month.sync="date_from.url_publish_time_to_m"
                                    :day.sync="date_from.url_publish_time_to_d"
                                    :full_date.sync="date_from.url_publish_time_to"
                                    :config="{
                                        error: false
                                    }"
                                >
                                </DateNormal>
                                から
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'url_publish_time_to')">クリア</button>
                            </div>
                            ～
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_to.url_publish_time_to_y"
                                    :month.sync="date_to.url_publish_time_to_m"
                                    :day.sync="date_to.url_publish_time_to_d"
                                    :full_date.sync="date_to.url_publish_time_to"
                                    :config="{
                                        error: false
                                    }"
                                >
                                </DateNormal>
                                まで
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'url_publish_time_to')">クリア</button>
                            </div>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">IPコンテンツ有無</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listInformationIp"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.information_ip"
                                :name="`informationIp-${item.id}`"
                                :id="`informationIp-${item.id}`"
                                :value="item.id"
                                :label="item.value"
                            />
                        </div>
                    </div>
                </div>

                <template v-for="item in listInformationIp">
                    <div
                        :key="'informationIpChild-' + item.id"
                        class="form-group row"
                        v-if="filter.information_ip.includes(item.id) && item.data && item.data.length > 0"
                    >
                        <label class="col-sm-3" for="validationCustom05">{{ item.value }}: IPコンテンツ詳細</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                <InputCheckBox
                                    v-for="child in item.data"
                                    :key="child.id"
                                    class="mr-4"
                                    :model.sync="filter.information_ip_detail"
                                    :name="`informationIpChild-${child.id}`"
                                    :id="`informationIpChild-${child.id}`"
                                    :value="child.id"
                                    :label="child.value"
                                />
                            </div>
                        </div>
                    </div>
                </template>

                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">IPコンテンツ詳細含自由記述</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordInformationIpDetail" class="" />
                    </div>
                </div>


                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">キャンペーン主催情報</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listSponsorInformation"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.sponsor_information"
                                :name="`sponsorInformation-${item.id}`"
                                :id="`sponsorInformation-${item.id}`"
                                :value="item.id"
                                :label="item.value"
                            />
                        </div>
                    </div>
                </div>
                
                <div class="form-group row" v-if="filter.sponsor_information && filter.sponsor_information.includes(258)">
                    <label class="col-sm-3" for="validationCustom05">タイアップ流通数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.circulation_number_from" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.circulation_number_to" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">タイアップ流通数報詳細</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordTieUpDistributionName" class="" />
                    </div>
                </div>
                <div class="form-group row" v-if="filter.sponsor_information && filter.sponsor_information.includes(258)">
                    <label class="col-sm-3" for="validationCustom05">タイアップメーカー数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.up_manufacturers_from" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.up_manufacturers_to" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">タイアップメーカー数報詳細</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordTieUpManufacturerName" class="" />
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('site')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【賞品・当選関連】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.prize" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.prize" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">総当選者数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.total_win_from" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.total_win_to" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">賞品進呈時期</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                            <div class="d-flex align-items-center mb-2">
                                <DateYearMonth
                                    :year.sync="date_from.prize_shipping_period_y"
                                    :month.sync="date_from.prize_shipping_period_m"
                                    :full_date.sync="date_from.prize_shipping_period"
                                    :config="{
                                        error: false
                                    }"
                                >
                                </DateYearMonth>
                                から
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'prize_shipping_period')">クリア</button>
                            </div>
                            ～
                            <div class="d-flex align-items-center mb-2">
                                <DateYearMonth
                                    :year.sync="date_to.prize_shipping_period_y"
                                    :month.sync="date_to.prize_shipping_period_m"
                                    :full_date.sync="date_to.prize_shipping_period"
                                    :config="{
                                        error: false
                                    }"
                                >
                                </DateYearMonth>
                                まで
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'prize_shipping_period')">クリア</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">賞品個数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.quantity_for_event_prize" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.quantity_for_event_prize" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">賞品タイトル+賞品名</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordPrizeSearch" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">当選人数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.number_of_win_prize" :config.sync="configTotalWin" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.number_of_win_prize" :config.sync="configTotalWin" />
                            まで
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">賞品種類</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listTypeTitlePrize"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.prize_type"
                                :name="`prizeType-${item.id}`"
                                :id="`prizeType-${item.id}`"
                                :value="item.id"
                                :label="item.value"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row" v-if="filter.prize_type.length > 0">
                    <label class="col-sm-3" for="validationCustom05">賞品種類の詳細</label>
                    <div class="col-sm-9">
                        <div v-for="prizeType in listTypeTitlePrize" :key="prizeType.id">
                            <div v-if="filter.prize_type.includes(prizeType.id)">
                                <label for="" class="mb-2">{{ prizeType.value }}:</label>
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="item in prizeType.data"
                                        :key="item.id"
                                        class="mr-4"
                                        :model.sync="filter.prize_type_detail"
                                        :name="`prizeType-${prizeType.id}-${item.id}`"
                                        :id="`prizeType-${prizeType.id}-${item.id}`"
                                        :value="item.id"
                                        :label="item.value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('prize')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【お問い合わせ関連】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.inquiry" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.inquiry" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">お問い合わせ事務局名</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordOffice" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">事務局電話番号</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordPhoneInformation" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">事務局メールアドレス</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordMailInformation" class="" />
                    </div>
                </div> 
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">お問い合わせDM対応アカウント</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordContactInformationDm" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">総お問い合わせ数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText class="mr-2" :model.sync="date_from.total_inquiry_from" :config.sync="configTotalInquiry" />
                            から
                        </div>
                        <div class="d-flex align-items-center">
                            <InputText class="mr-2" :model.sync="date_to.total_inquiry_to" :config.sync="configTotalInquiry" />
                            まで
                        </div>
                    </div>
                </div>
                <div v-for="item in listFilterScopeInquiry" :key="item.id + 'label'"  class="form-group row">
                    <label class="col-sm-3">{{ item.value }}：お問い合わせ数</label>
                    <div class="col-sm-9 d-flex">
                        <div class="d-flex align-items-center mr-2">
                            <InputText
                                class="mr-2"
                                :model="number_of_inquiries[item.id] ? number_of_inquiries[item.id].from : ''"
                                @input="updateNumberOfInquiries(item.id, 'from', $event)"
                                :config="configTotalWin"
                            />
                            から
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <InputText
                                class="mr-2"
                                :model="number_of_inquiries[item.id] ? number_of_inquiries[item.id].to : ''"
                                @input="updateNumberOfInquiries(item.id, 'to', $event)"
                                :config="configTotalWin"
                            />
                            まで
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('inquiry')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【その他】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.other" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.other" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">生成日</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_from.campaign_create_date_y"
                                    :month.sync="date_from.campaign_create_date_m"
                                    :day.sync="date_from.campaign_create_date_d"
                                    :full_date.sync="date_from.campaign_create_date"
                                    :config="{
                                        error: false
                                    }"
                                ></DateNormal>
                                から
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'campaign_create_date')">クリア</button>
                            </div>
                            ～
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :year.sync="date_to.campaign_create_date_y"
                                    :month.sync="date_to.campaign_create_date_m"
                                    :day.sync="date_to.campaign_create_date_d"
                                    :full_date.sync="date_to.campaign_create_date"
                                    :config="{
                                        error: false
                                    }"
                                >
                                </DateNormal>
                                まで
                                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'campaign_create_date')">クリア</button>
                            </div>
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">作成者</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-created_by-advanced`"
                            :value="created_by"
                            :options="listEmployee"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:created_by', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">自由記述</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordOverviewInformation" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">ZACID</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordZacId" class="" />
                    </div>
                </div>
                
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">SFID</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordSfid" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">CAM-SAKU ID</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordCampaignEntityId" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">検索キーワード</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordKeywords" class="" />
                    </div>
                </div>
                
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">メモ欄</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordMemo" class="" />
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('other')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【受注範囲＆パートナー＆ツール】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.scope" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.scope" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">受注範囲大項目</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <InputCheckBox
                                v-for="orderLv1 in listDataMasterOrderScope"
                                :key="orderLv1.id"
                                class="mr-4 py-1"
                                :model.sync="filter.order_scope_large"
                                :id="`orderScopeLargeItem${orderLv1.id}`"
                                :name="`orderScopeLargeItem${orderLv1.id}`"
                                :value="orderLv1.id"
                                :label="orderLv1.value"
                            />
                        </div>
                    </div>
                </div>

                <div v-if="isSelectedDepartment" class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">受注範囲-資料系</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listFilterScopeDepartment"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.order_scope_department"
                                :name="`orderScopeDepartment`"
                                :id="`orderScopeDepartment-${item.id}`"
                                :value="item.id"
                                :label="item.value"
                            />
                        </div>
                    </div>
                </div>
                <div v-if="isSelectedInquiry" class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">受注範囲-お問い合わせ+詳細</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listFilterScopeInquiry"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.order_scope_inquiry"
                                :name="`orderScopeInquiry`"
                                :id="`orderScopeInquiry-${item.id}`"
                                :value="item"
                                :label="item.value"
                                @change="handleChangeFilterInquiry(item)"
                            />
                        </div>
                        <div v-for="item in listFilterScopeInquiry" :key="item.id + 'label'">
                            <template
                                v-if="
                                    filter.order_scope_inquiry.map((item) => item.id).includes(item.id) &&
                                    item.data.length > 0
                                "
                            >
                                <hr />
                                <label>{{ item.value }}:</label>
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="detail in item.data"
                                        :key="detail.id"
                                        class="mr-4"
                                        :model.sync="filter.order_scope_inquiry_detail"
                                        :name="`orderScopeInquiryDetail-${detail.id}`"
                                        :id="`orderScopeInquiryDetail-${detail.id}`"
                                        :value="detail"
                                        :label="detail.value"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div v-if="isSelectedApplication" class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">受注範囲-応募収集+詳細</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listFilterScopeApplication"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.order_scope_application"
                                :name="`orderScopeApplication`"
                                :id="`orderScopeApplication-${item.id}`"
                                :value="item"
                                :label="item.value"
                                @change="handleChangeFilterApplication(item)"
                            />
                        </div>
                        <div v-for="item in listFilterScopeApplication" :key="item.id + 'label'">
                            <template
                                v-if="
                                    filter.order_scope_application.map((item) => item.id).includes(item.id) &&
                                    item.data.length > 0
                                "
                            >
                                <hr />
                                <label>{{ item.value }}:</label>
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="detail in item.data"
                                        :key="detail.id"
                                        class="mr-4"
                                        :model.sync="filter.order_scope_application_detail"
                                        :name="`orderScopeApplicationDetail-${detail.id}`"
                                        :id="`orderScopeApplicationDetail-${detail.id}`"
                                        :value="detail"
                                        :label="detail.value"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div v-if="isSelectedSecretariat" class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">受注範囲-事務局関連+詳細</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listFilterScopeSecretariat"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.order_scope_secretariat"
                                :name="`orderScopeSecretariat`"
                                :id="`orderScopeSecretariat-${item.id}`"
                                :value="item"
                                :label="item.value"
                                @change="handleChangeFilterSecretariat(item)"
                            />
                        </div>
                        <div v-for="item in listFilterScopeSecretariat" :key="item.id + 'label'">
                            <template
                                v-if="
                                    filter.order_scope_secretariat.map((item) => item.id).includes(item.id) &&
                                    item.data.length > 0
                                "
                            >
                                <hr />
                                <label>{{ item.value }}:</label>
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="detail in item.data"
                                        :key="detail.id"
                                        class="mr-4"
                                        :model.sync="filter.order_scope_secretariat_detail"
                                        :name="`orderScopeSecretariatDetail-${detail.id}`"
                                        :id="`orderScopeSecretariatDetail-${detail.id}`"
                                        :value="detail"
                                        :label="detail.value"
                                        @change="handleChangeFilterSecretariatDetail(detail)"
                                    />
                                </div>
                                <template v-for="detail in item.data">
                                    <div
                                        v-if="
                                            filter.order_scope_secretariat_detail.some((d) => d.id === detail.id) &&
                                            detail.data &&
                                            detail.data.length > 0
                                        "
                                        :key="detail.id + 'level3'"
                                    >
                                        <hr style="border-top: 1px dashed #ccc" />
                                        <label class="ml-3">{{ detail.value }}:</label>
                                        <div class="d-flex flex-wrap mb-2 ml-3" style="gap: 10px">
                                            <InputCheckBox
                                                v-for="subDetail in detail.data"
                                                :key="subDetail.id"
                                                class="mr-4"
                                                :model.sync="filter.order_scope_secretariat_detail"
                                                :name="`orderScopeSecretariatSubDetail-${subDetail.id}`"
                                                :id="`orderScopeSecretariatSubDetail-${subDetail.id}`"
                                                :value="subDetail"
                                                :label="subDetail.value"
                                            />
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
                <div v-if="isSelectedShipping" class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">受注範囲-発送+詳細</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listFilterScopeShipping"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.order_scope_shipping"
                                :name="`orderScopeShipping`"
                                :id="`orderScopeShipping-${item.id}`"
                                :value="item"
                                :label="item.value"
                                @change="handleChangeFilterShipping(item)"
                            />
                        </div>
                        <div v-for="item in listFilterScopeShipping" :key="item.id + 'label'">
                            <template
                                v-if="
                                    filter.order_scope_shipping.map((item) => item.id).includes(item.id) &&
                                    item.data.length > 0
                                "
                            >
                                <hr />
                                <label>{{ item.value }}:</label>
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="detail in item.data"
                                        :key="detail.id"
                                        class="mr-4"
                                        :model.sync="filter.order_scope_shipping_detail"
                                        :name="`orderScopeShippingDetail-${detail.id}`"
                                        :id="`orderScopeShippingDetail-${detail.id}`"
                                        :value="detail"
                                        :label="detail.value"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div v-if="isSelectedProduction" class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">受注範囲-制作関連+詳細</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listFilterScopeProduction"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.order_scope_production"
                                :name="`orderScopeProduction`"
                                :id="`orderScopeProduction-${item.id}`"
                                :value="item"
                                :label="item.value"
                                @change="handleChangeFilterProduction(item)"
                            />
                        </div>
                        <div v-for="item in listFilterScopeProduction" :key="item.id + 'label'">
                            <template
                                v-if="
                                    filter.order_scope_production.map((item) => item.id).includes(item.id) &&
                                    item.data.length > 0
                                "
                            >
                                <hr />
                                <label>{{ item.value }}:</label>
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="detail in item.data"
                                        :key="detail.id"
                                        class="mr-4"
                                        :model.sync="filter.order_scope_production_detail"
                                        :name="`orderScopeProductionDetail-${detail.id}`"
                                        :id="`orderScopeProductionDetail-${detail.id}`"
                                        :value="detail"
                                        :label="detail.value"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div v-if="isSelectedSns" class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">受注範囲-SNSアカウント関連+詳細</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listFilterScopeSns"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.order_scope_sns_account"
                                :name="`orderScopeSns`"
                                :id="`orderScopeSns-${item.id}`"
                                :value="item"
                                :label="item.value"
                                @change="handleChangeFilterSns(item)"
                            />
                        </div>
                        <div v-for="item in listFilterScopeSns" :key="item.id + 'label'">
                            <template
                                v-if="filter.order_scope_sns_account.map((item) => item.id).includes(item.id) && item.data.length > 0"
                            >
                                <hr />
                                <label>{{ item.value }}:</label>
                                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                    <InputCheckBox
                                        v-for="detail in item.data"
                                        :key="detail.id"
                                        class="mr-4"
                                        :model.sync="filter.order_scope_sns_account_detail"
                                        :name="`orderScopeSnsDetail-${detail.id}`"
                                        :id="`orderScopeSnsDetail-${detail.id}`"
                                        :value="detail"
                                        :label="detail.value"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">パートナー：受注範囲-お問い合わせ</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-scope_partner_inquiry-advanced`"
                            :value="scope_partner_inquiry"
                            :options="listAllPartnersInquiry"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:scope_partner_inquiry', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">パートナー：受注範囲-応募収集</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-scope_partner_application-advanced`"
                            :value="scope_partner_application"
                            :options="listAllPartnersApplication"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:scope_partner_application', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">パートナー：受注範囲-事務局関連</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-scope_partner_secretariat-advanced`"
                            :value="scope_partner_secretariat"
                            :options="listAllPartnersSecretariat"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:scope_partner_secretariat', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">パートナー：受注範囲-発送</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-scope_partner_shipping-advanced`"
                            :value="scope_partner_shipping"
                            :options="listAllPartnersShipping"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:scope_partner_shipping', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05"
                        >ツール：受注範囲-応募収集<br />ツール：受注範囲-事務局関連</label
                    >
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-tool-advanced`"
                            :value="tool"
                            :options="listAllTools"
                            :config="{
                                trackBy: 'id',
                                label: 'tool',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:tool', $event)"
                        />
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('scope')">クリア</button>
                </div>
            </div>
        </div>
        
        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【お客様情報】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.customer" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.customer" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">発注元</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordOrderSource" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">エンドクライアント</label>
                    <div class="col-sm-9">
                        <KeyWordTag :config="configKeywordGenerateFile" class="" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">発注元の顧客種別</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in OPTIONS_TYPE"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.client_order_source_type"
                                :name="`clientOrderSourceType-${item.id}`"
                                :id="`clientOrderSourceType-${item.id}`"
                                :value="item.id"
                                :label="item.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">エンドクライアントの顧客種別</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in OPTIONS_TYPE"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.client_generate_file_type"
                                :name="`clientGenerateFileType-${item.id}`"
                                :id="`clientGenerateFileType-${item.id}`"
                                :value="item.id"
                                :label="item.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('customer')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【事務局担当情報】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.staff" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.staff" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">営業担当</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-sale_staff-advanced`"
                            :value="sale_staff"
                            :options="listDataMasterSaleStaf"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:sale_staff', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">ディレクションメイン担当</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-person_in_charge-advanced`"
                            :value="person_in_charge"
                            :options="listDataMasterInstructorStaf"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:person_in_charge', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">ディレクションサブ1担当＆2担当</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-responsible_sub_persons-advanced`"
                            :value="responsible_sub_persons"
                            :options="listDataMasterInstructorStaf"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:responsible_sub_persons', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">案件統括</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-project_management-advanced`"
                            :value="project_management"
                            :options="listProjectManagement"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:project_management', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">エスカレメイン担当</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-customer_team_pic-advanced`"
                            :value="customer_team_pic"
                            :options="listDataCustomerTeamPic"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:customer_team_pic', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">エスカレサブ担当</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-customer_sub_person-advanced`"
                            :value="customer_sub_person"
                            :options="listDataCustomerTeamPic"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:customer_sub_person', $event)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">アルバイト</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-part_time_employee-advanced`"
                            :value="part_time_employee"
                            :options="listDataMasterParttime"
                            :config="{
                                trackBy: 'id',
                                label: 'name',
                                multiple: true,
                                closeOnSelect: false,
                                error: false,
                                isRemove: false,
                                loading: false
                            }"
                            @update:value="$emit('update:part_time_employee', $event)"
                        />
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('staff')">クリア</button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="d-flex card-header" style="gap: 0.5rem">
                <h6 class="mb-0">【広告関連】</h6>
                <div class="ml-auto">
                    <ButtonActiveFilter :active.sync="activeAccordions.advertising" :smallCol="672" :largeCol="50" sizeBtn="sm"/>
                </div>
            </div>
            <div v-show="activeAccordions.advertising" class="p-4">
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">広告運用有無</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in listDataMasterCampaignAdvertising"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.advertising_activity_id"
                                :name="`advertisingActivity-${item.id}`"
                                :id="`advertisingActivity-${item.id}`"
                                :value="item.id"
                                :label="item.value"
                            />
                        </div>
                    </div>
                </div>
                <template v-if="showAdvertisingDetails">
                    <div class="form-group row">
                        <label class="col-sm-3" for="validationCustom05">媒体</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                                <InputCheckBox
                                    v-for="item in listSocialPlatform"
                                    :key="item.id"
                                    class="mr-4"
                                    :model.sync="filter.social_platform_id"
                                    :name="`socialPlatform-${item.id}`"
                                    :id="`socialPlatform-${item.id}`"
                                    :value="item.id"
                                    :label="item.value"
                                />
                            </div>
                        </div>
                    </div>
                    <template v-for="item in listSocialPlatform">
                        <div
                            class="form-group row"
                            v-if="filter.social_platform_id && filter.social_platform_id.includes(item.id)"
                            :key="'socialCost-' + item.id"
                        >
                            <label class="col-sm-3">{{ item.value }}: 費用</label>
                            <div class="col-sm-9 d-flex">
                                <div class="d-flex align-items-center mr-2">
                                    <InputText
                                        class="mr-2"
                                        :model="social_platforms[item.id] ? social_platforms[item.id].from : ''"
                                        @input="updateSocialPlatforms(item.id, 'from', $event)"
                                        :config="configTotalWin"
                                    />
                                    から
                                </div>
                                <div class="d-flex align-items-center">
                                    <InputText
                                        class="mr-2"
                                        :model="social_platforms[item.id] ? social_platforms[item.id].to : ''"
                                        @input="updateSocialPlatforms(item.id, 'to', $event)"
                                        :config="configTotalWin"
                                    />
                                    まで
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <div class="form-group row">
                    <label class="col-sm-3" for="validationCustom05">GA関連タグ埋め込み有無</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <InputCheckBox
                                class="mr-3 mb-2"
                                :model.sync="filter.give_away_related"
                                id="check-give_away_related-1"
                                value="1"
                                label="あり"
                            />
                            <InputCheckBox
                                class="mr-3 mb-2"
                                :model.sync="filter.give_away_related"
                                id="check-give_away_related-0"
                                value="0"
                                label="なし"
                            />
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-common btn-outline-secondary" @click="clearSection('advertising')">クリア</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
:deep(.card-header) {
    padding: 0.5rem 1rem;
    background-color: #f1f0f0;
}
</style>